import httpClient from './httpClient';

const ps_order_detail_update = (order_detail) => httpClient.put('/api/ps_order_detail/'+order_detail.id_order_detail,order_detail);

export {
    ps_order_detail_update
}